import React from 'react';
import { FormattedMessage } from 'react-intl';
import './InCategorySearchHeaderInline.scss';

const InCategorySearchHeaderInline = () => (
    <div className="intra-category__header--inline">
        <FormattedMessage
            id="listing.search.category.title.inline"
            defaultMessage="in the category"
            description="Label of category search header component"
        />
    </div>
);

InCategorySearchHeaderInline.displayName = 'InCategorySearchHeaderInline';

export default InCategorySearchHeaderInline;
